import React, { Component } from 'react';
import './StaticFilterInput.css';
import utils from '../../utils/utils';
import debounce from 'lodash.debounce';
import clone from 'lodash.clone';

import DropDownSelectMany from '../../components/dropDownSelectMany/DropDownSelectMany';
import DateRangePicker from '../../components/dateRangePicker/DateRangePicker';

let defaultState = { selectedOption: null, searchValue: null, datetime: null };

export default class StaticFilterInput extends Component {
	constructor(props) {
		super(props);
		this.state = {
			currentFilter: this.props.currentFilter
		};
	}

	componentDidMount = () => {
		document.body.addEventListener('click', this._backgroundClick, true);
	};

	componentWillUnmount = () => {
		document.body.removeEventListener('click', this._backgroundClick, true);
	};

	_backgroundClick = (e) => {
		if (this.node.contains(e.target)) return;
		this.setState(defaultState);
	};

	_removeFilter = (option, value) => {
		let currentFilter = this.state.currentFilter || [];
		let selectedOption = this.props.options[option];
		let newFilter = [];
		for (let i in currentFilter) {
			let filter = currentFilter[i];
			if (selectedOption.column === filter.column && value == filter.value) {
				continue;
			}
			newFilter.push(filter);
		}
		let state = clone(defaultState);
		state.currentFilter = newFilter;
		this.setState(state, this._onChange);
	};

	_removeAllFiltersOfType = (option, callback) => {
		let currentFilter = this.state.currentFilter || [];
		let selectedOption = this.props.options[option];
		let newFilter = [];
		for (let i in currentFilter) {
			let filter = currentFilter[i];
			if (selectedOption.column === filter.column) {
				continue;
			}
			newFilter.push(filter);
		}
		let state = clone(defaultState);
		state.currentFilter = newFilter;
		this.setState(state, () => {
			if (callback) callback();
			this._onChange();
		});
	};

	_addFilter = (option, value, name, remove) => {
		if (remove) return this._removeFilter(option, value);
		if (value == -1) return this._removeAllFiltersOfType(option);
		let currentFilter = this.state.currentFilter || [];
		let selectedOption = this.props.options[option];
		currentFilter.push({ value, name, column: selectedOption.column, displayName: selectedOption.displayName });
		let state = clone(defaultState);
		state.currentFilter = currentFilter;

		this.setState(state, this._onChange);
	};

	getValue = () => {
		let currentFilter = this.state.currentFilter;
		let value = {};
		for (let i in currentFilter) {
			let column = currentFilter[i].column;
			if (!value[column]) value[column] = { values: [] };
			value[column].values.push(currentFilter[i].value);
		}
		return value;
	};

	_onChange = debounce(() => {
		let value = this.getValue();
		if (this.props.onChange) this.props.onChange(value);
	}, 200);

	setDateFilter = (dates, filterOption) => {
		this._removeAllFiltersOfType(filterOption, () => {
			let currentFilter = this.state.currentFilter || [];
			if (dates.startDate) {
				currentFilter.push(this.getDateFilter(dates.startDate, '>'));
			}
			if (dates.endDate) {
				currentFilter.push(this.getDateFilter(dates.endDate, '<'));
			}
		});
	};

	getDateFilter = (datetime, operator) => {
		return {
			value: { datetime, operator },
			name: utils.display_actual_datetime(datetime),
			column: 'created_on'
		};
	};

	_renderOptions = () => {
		let opt = [];
		for (let i in this.props.options) {
			let item = this.props.options[i];
			let displayFields = this.props.displayFields || ['name'];
			let name = [];
			for (let j in displayFields) {
				name.push(item[displayFields[j]]);
			}
			if (item.type === 'datetime') {
				opt.push(
					<DateRangePicker
						value={'24'}
						onChange={(value) => {
							this.setDateFilter(value, i);
						}}
					/>
				);
				continue;
			}
			opt.push(
				<DropDownSelectMany
					noSearch={item.noSearch}
					plural={item.plural}
					onChange={(value, display, remove, alternateValue) => {
						this._addFilter(i, alternateValue || value, display, remove);
					}}
					className="initial-option"
					displayFields={item.filterColumns}
					model={item.model}
					placeholder={item.placeholder}
					subscribeTo={item.model}
					columns={item.columns}
					options={item.options}
					key={i}
				>
					{item.displayName}
				</DropDownSelectMany>
			);
		}
		return <div className="options-container">{opt}</div>;
	};

	render() {
		return (
			<div className="g-static-filter-input" ref={(ref) => (this.node = ref)}>
				{this._renderOptions()}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/inputs/staticFilterInput/StaticFilterInput.jsx